import Navigation from "@/components/Navigation";
import ContactForm from "@/components/ContactForm";
import FooterWithNewsletter from "@/components/ui/footer-column";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5 }
  }
};

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      {/* Two Column Layout */}
      <section className="py-24 bg-background">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            {/* Left Column - Header & Contact Info */}
            <motion.div 
              className="text-left space-y-8"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <motion.div variants={itemVariants}>
                <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
                  Contact Us
                </h1>
                <p className="text-xl text-muted-foreground">
                  Get in touch with our team. We'd love to hear from you and help with any questions you may have.
                </p>
              </motion.div>

              {/* Email Section */}
              <motion.div variants={itemVariants}>
                <h3 className="font-semibold text-foreground mb-2">Email</h3>
                <a 
                  href="mailto:support@gimmefy.ai" 
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  support@gimmefy.ai
                </a>
              </motion.div>

              {/* Address Section */}
              <motion.div variants={itemVariants}>
                <h3 className="font-semibold text-foreground mb-4">Address</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Singapore */}
                  <motion.div 
                    className="space-y-3 flex flex-col"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.2 }}
                  >
                    <h4 className="font-medium text-foreground">Singapore (HQ)</h4>
                    <p className="text-sm text-muted-foreground flex-grow">
                      3 Temasek Avenue, Centennial Tower, #17/18<br />
                      Singapore 039190
                    </p>
                    <a 
                      href="https://www.google.com/maps/place/Centennial+Tower/@1.2934775,103.8594763,17z"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-1"
                    >
                      Open in Google Maps →
                    </a>
                  </motion.div>

                  {/* New York */}
                  <motion.div 
                    className="space-y-3 flex flex-col"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.2 }}
                  >
                    <h4 className="font-medium text-foreground">New York</h4>
                    <p className="text-sm text-muted-foreground flex-grow">
                      575 5th Ave<br />
                      New York, NY 10017
                    </p>
                    <a 
                      href="https://www.google.com/maps/place/575+5th+Ave,+New+York,+NY+10017"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-1"
                    >
                      Open in Google Maps →
                    </a>
                  </motion.div>
                </div>
              </motion.div>
            </motion.div>

            {/* Right Column - Form */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <ContactForm />
            </motion.div>
          </div>
        </div>
      </section>

      <FooterWithNewsletter />
    </div>
  );
};

export default ContactPage;
